import React from 'react'
import Draggable from "../../../DnD/Draggable";
import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Signature() {
    return (
        <Draggable id="input-signature">
            <InputWrapper>
                Signature
                <div className={classNames("date","signature")}>
                    ..........
                </div>
            </InputWrapper>
        </Draggable>
    )
}

export default Signature
